import React from 'react';
import { CompanyHero } from '../components/company/CompanyHero';
import { TextImageRow } from '../components/company/TextImageRow';
import { StatsRow } from '../components/company/StatsRow';
import { CardGrid } from '../components/company/CardGrid';
import { LeadershipGrid } from '../components/company/LeadershipGrid';
import { LogoStrip } from '../components/company/LogoStrip';
import { OfficeCard } from '../components/company/OfficeCard';
import { CtaBand } from '../components/company/CtaBand';
import { aboutStats, companyImages, leaders, officeAddress, partnersPlaceholder, values, whatWeDo } from '../data/company';
export function About() {
  return <main data-id="element-1731" data-mp="2x97ss1pry7of">
      <CompanyHero eyebrow="About Kayko" headline="Building the financial backbone for Rwanda’s small businesses" subheadline="We give shop owners, restaurants, clinics, and service businesses the tools to run, get paid, and grow — all in one place." image={{
      src: companyImages.aboutHero,
      alt: 'A busy Kigali street market, with a shop owner recording a sale on a tablet'
    }} data-id="element-1732" data-mp="2x8y0u8l65qg3" />

      <TextImageRow id="story-heading" eyebrow="Our story" title="Started in Kigali, built with the businesses we serve" paragraphs={['Kayko was founded in 2021 with a simple idea: small businesses in Rwanda deserve the same clear view of their numbers as large companies. Too many owners were running shops from notebooks, memory, and a drawer of receipts.', 'We started with tools to record sales, track stock, and manage expenses. As our customers grew, so did we — adding payments and, through licensed partners, access to business financing. Today Kayko is one integrated platform that helps businesses run their day and plan their next step.']} image={{
      src: companyImages.aboutStory,
      alt: 'The Kayko team showing a shop owner a business dashboard in their Kigali office'
    }} data-id="element-1733" data-mp="1pk9tb53ki006" />

      <StatsRow stats={aboutStats} label="Kayko in numbers" data-id="element-1734" data-mp="1ovxu9wrqyyea" />

      <CardGrid id="values-heading" title="Mission and values" subtitle="Our mission is to help every small business in Rwanda run with clarity and grow with confidence." items={values} columns={4} tone="warm" data-id="element-1735" data-mp="1svyj8bch2rzl" />

      <CardGrid id="what-we-do-heading" title="What we do" subtitle="Three connected parts of one platform." items={whatWeDo} columns={3} data-id="element-1736" data-mp="22o49ngn2t1co" />

      <LeadershipGrid leaders={leaders} data-id="element-1737" data-mp="2cie371nr85oz" />

      <LogoStrip id="partners-heading" title="Our partners" subtitle="We work with banks, payment providers, and development partners across Rwanda." count={partnersPlaceholder} data-id="element-1738" data-mp="2gm2cbos1b9cc" />

      <OfficeCard address={officeAddress} data-id="element-1739" data-mp="m8kxqr9lxmtg" />

      <CtaBand headline="Join us" subheadline="Help us build tools that move Rwanda’s small businesses forward." primary={{
      label: 'View careers',
      href: '/careers'
    }} secondary={{
      label: 'Contact us',
      href: '/contact'
    }} data-id="element-1740" data-mp="m9w0cnrbgoiz" />
    </main>;
}